import { toReadableTotal } from "../../utils/orderUtils";

export default function OrderDiscount({order}) {
    if (!order) return null;

    return (
        <div className="table-container">
            <table className="table">
                <tbody>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Coupon Code:
                        </td>
                        <td style={{ 
                            fontFamily: 'var(--font-family-mono)', 
                            fontWeight: 'var(--font-weight-medium)',
                            color: 'var(--text-secondary)'
                        }}>
                            {order.discount.code}
                        </td>
                    </tr>
                    {order.discount.amount_off && (
                        <tr>
                            <td style={{ 
                                fontWeight: 'var(--font-weight-semibold)', 
                                color: 'var(--text-primary)',
                                paddingRight: 'var(--spacing-xl)',
                                minWidth: '150px'
                            }}>
                                Amount Off:
                            </td>
                            <td style={{ 
                                fontWeight: 'var(--font-weight-semibold)', 
                                color: 'var(--error-color)'
                            }}>
                                -${toReadableTotal(order.discount.amount_off)}
                            </td>
                        </tr>
                    )}
                    {order.discount.percent_off && (
                        <tr>
                            <td style={{ 
                                fontWeight: 'var(--font-weight-semibold)', 
                                color: 'var(--text-primary)',
                                paddingRight: 'var(--spacing-xl)',
                                minWidth: '150px'
                            }}>
                                Percent Off:
                            </td>
                            <td style={{ 
                                fontWeight: 'var(--font-weight-semibold)', 
                                color: 'var(--error-color)'
                            }}>
                                {order.discount.percent_off}%
                            </td>
                        </tr>
                    )}
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Discounted Total:
                        </td>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)'
                        }}>
                            ${toReadableTotal(order.discount.total_discount)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Times Redeemed:
                        </td>
                        <td style={{ color: 'var(--text-secondary)' }}>
                            {order.discount.times_redeemed}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Max Redemptions:
                        </td>
                        <td style={{ color: 'var(--text-secondary)' }}>
                            {order.discount.max_redemptions}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}